import { LoadingScreen } from '@/components/common/LoadingScreen';
import { useAuth } from '@/hooks/useAuth';
import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Gates routes that a PENDING_DEBT-only user must not access. Such a user
 * (debt pending, no operational role) is redirected to their only allowed
 * screen: the current-account page, where they can see and settle the debt.
 *
 * A pure ADMIN is sent to the backoffice for the same reason: these screens
 * hang off owner-scoped queries, so they render empty and fire fetches that
 * answer 403 — which the API interceptor reads as an expired session.
 */
export const RequirePanelAccess: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isUserReady, isPendingDebtOnly, isPureAdmin } = useAuth();

  // `isLoadingUser` alone is not enough: it starts out false, with the roles
  // still on their way.
  if (!isUserReady) {
    return <LoadingScreen />;
  }

  if (isPendingDebtOnly) {
    return <Navigate to="/cuenta-corriente" replace />;
  }

  if (isPureAdmin) {
    return <Navigate to="/admin/usuarios" replace />;
  }

  return <>{children}</>;
};
